export enum EOrderSheetClass {
  ITEM = 'ITEM',
  SERVICE = 'SERVICE',
}



export default EOrderSheetClass;
